  var map, cache_data, bounds;
  var m_lat,m_long;

  function loadMap(){

  m_lat = jQuery('#office-map').data('lat');
  m_long = jQuery('#office-map').data('long');
  var ltlng = new google.maps.LatLng(m_lat, m_long);


    map = new google.maps.Map(document.getElementById('office-map'), {
       zoom: 14,
      center: ltlng,
      styles: [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
]
    });

    var marker = new google.maps.Marker({
      map: map, 
      position: ltlng,
      animation: google.maps.Animation.DROP,
      title: 'Roberson Building Group',
                icon: { url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='39.4' height='60.46' viewBox='0 0 39.4 60.46'%3E%3Cpath d='M124.31,412.54A19.71,19.71,0,0,0,115.65,450L124,472.8a.31.31,0,0,0,.58,0L132.86,450a19.7,19.7,0,0,0-8.55-37.45Zm0,33.24a13.54,13.54,0,1,1,13.54-13.54A13.53,13.53,0,0,1,124.31,445.78Z' transform='translate(-104.6 -412.54)' style='fill:%23233256'/%3E%3C/svg%3E", scaledSize: new google.maps.Size(40, 40) },optimized: false
    });

  }

jQuery(document).ready(function() {

   var rs_contact_form = FormValidation.formValidation(
            document.getElementById('rs-contact-form'), {
              plugins: {
                declarative: new FormValidation.plugins.Declarative({
                  html5Input: true,
                }),
                bootstrap: new FormValidation.plugins.Bootstrap(),
                excluded: new FormValidation.plugins.Excluded(),
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton()
              },
            }
          ).on('core.form.valid', function() {
            var rsfullnews_submitButton = document.getElementById('rs-contact-form').querySelector('[type="submit"]');
            rsfullnews_submitButton.setAttribute('disabled', 'disabled');
            jQuery.ajax({
              url: jQuery('#rs-contact-form').data('url'),
              type: 'post',
              data: jQuery('#rs-contact-form').serialize(),
              dataType: 'json',
              success: function(ret) {
                rs_contact_form.resetForm(true);
                jQuery('#rs-contact-form').get(0).reset();
                jQuery.fancybox.open(ret.data.message);

                setTimeout(function() {
                  rsfullnews_submitButton.removeAttribute('disabled');
                  jQuery.fancybox.close();
                }, 3500);

              },
              error: function(ret){
                jQuery.fancybox.open('<h3>There has been an error.</h3><p>Please try again.</p>');

                setTimeout(function() {
                  rsfullnews_submitButton.removeAttribute('disabled');
                  jQuery.fancybox.close();
                }, 3500);
              }
            });

          });


  var p = document.createElement('script');
  p.type = 'text/javascript';
  p.async = true;
  p.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBgd36wwsddQn9LMIP1Qb53xgNiaeREmtY&callback=loadMap';
  var z = document.getElementsByTagName('script')[0];
  z.parentNode.insertBefore(p, z);

  // Add Animation

    var $window = jQuery(window);
    var l = jQuery('.module-wrapper .l');
    var r = jQuery('.module-wrapper .r');

    var ANIM_contact_page = gsap.timeline({});
    ANIM_contact_page.from(l, {
        y: 120,
        duration: 0.7,
        autoAlpha: 0
    });
    ANIM_contact_page.from(r, {
        y: 120,
        duration: 0.7,
        autoAlpha: 0
    });

    ScrollTrigger.create({
        trigger: '.module-wrapper',
        top: 500,
        start: "top 60%",
        animation: ANIM_contact_page,
        toggleActions: 'play none play none'
    });

});